var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "#E6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0353 25.25V15.8281C24.0337 15.7243 24.012 15.6219 23.9716 15.5269C23.9313 15.4319 23.873 15.3462 23.8001 15.275L16.5649 8.45933C16.4315 8.33284 16.2572 8.2627 16.0765 8.2627C15.8957 8.2627 15.7215 8.33284 15.5881 8.45933L8.35279 15.275C8.27999 15.3462 8.22167 15.4319 8.18129 15.5269C8.1409 15.6219 8.11927 15.7243 8.11765 15.8281V25.25",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94705 25.25H26.2059",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2471 25.25V20C18.2471 19.8011 18.1708 19.6103 18.0351 19.4697C17.8995 19.329 17.7154 19.25 17.5235 19.25H14.6294C14.4375 19.25 14.2535 19.329 14.1178 19.4697C13.9821 19.6103 13.9059 19.8011 13.9059 20V25.25",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlue);
export default __webpack_public_path__ + "static/media/home-blue.30e7fcc4386fde5d21ddc135cbd1ae32.svg";
export { ForwardRef as ReactComponent };